import axios from 'axios';

class UploadAdapter {
  constructor (loader, url) {
    this.loader = loader;
    this.url = url;
  }
  upload () {
    const jwt = sessionStorage.getItem('jwt')
      ? sessionStorage.getItem('jwt') : localStorage.getItem('jwt')
        ? localStorage.getItem('jwt') : null;

    // upload file
    return this.loader.file
      .then(file => new Promise((resolve, reject) => {
        const bodyFormData = new FormData();
        bodyFormData.append('image', file);
        axios.post(this.url, bodyFormData,
          { headers: { 'Authorization': 'Bearer ' + jwt, 'Content-Type': 'application/x-www-form-urlencoded' } })
          .then(response => {
            if (!response.data) {
              throw new Error('data not found');
            }
            resolve(response.data.data);
          })
          .catch(error => {
            console.log(error.message);
            reject(error.message);
          });
      }));
  }

  abort () {
  }
};

export const CustomUploadAdapterPlugin = (editor) => {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new UploadAdapter(loader, editor.config.get('uploadUrl'));
  };
};
